module.exports = __webpack_public_path__ + "media/logos/spacelist-f2a74c35.png";